import type { SelectHTMLAttributes } from 'react';
import { findUsStateOption, US_STATES_AND_TERRITORIES } from '~/constants';

type Props = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'value' | 'onChange' | 'children'> & {
  /** A two-letter code, or '' for none. */
  value: string;
  onChange: (code: string) => void;
  emptyLabel?: string;
};

/**
 * A native dropdown of US states and territories for forms that manage their
 * own state rather than react-hook-form. A saved code that isn't in the list
 * is kept as its own option so opening an old record never silently clears it.
 */
export const UsStateSelect = ({
  value,
  onChange,
  emptyLabel = 'Not specified',
  ...rest
}: Props) => {
  const known = findUsStateOption(value);
  const selected = known?.value ?? value;
  return (
    <select {...rest} value={selected} onChange={(event) => onChange(event.target.value)}>
      <option value="">{emptyLabel}</option>
      {selected && !known && <option value={selected}>{selected}</option>}
      {US_STATES_AND_TERRITORIES.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label} ({option.value})
        </option>
      ))}
    </select>
  );
};
